import { DateTime } from "luxon";

export const MAP_QUERY_DEFAULTS = {
  ZOOM: 7,
  POINTRESULTZOOM: 15,
  CENTER: { lat: 37.9, lng: -121 },
  COORDINATES: {
    _northEast: { lat: 41, lng: -113 },
    _southWest: { lat: 35, lng: -128 },
  },
  LOCATEDBY: "",
  EXCAVATOR: "",
  WORKTYPE: "",
  TICKETTYPE: "",
  STATUS: "OPEN",
  STARTDATE: DateTime.now().minus({months: 6}),
  ENDDATE: DateTime.now(),
  PRIORITY: "NORM",
  MAXAREA: 50000, // sq Km
  MAXRESULTS: 5000,
};

export const USER_CONFIG_DEFAULTS = {
  INITIALMODE: null,
  FEATURES: {
    EMERGENCYMODE: true,
    POLYDRAW: false,
    USERLOCATE: true,
    POLLINGENABLED: process.env.REACT_APP_EMERGENCY_POLLING,
    DEVTOOLSENABLED: process.env.REACT_APP_DEVTOOLS,
  },
};
